export const UPDATE_ACCOUNT_INIT    = "UPDATE_ACCOUNT_INIT"
export const UPDATE_ACCOUNT_SUCCESS = "UPDATE_ACCOUNT_SUCCESS"
export const UPDATE_ACCOUNT_FAIL    = "UPDATE_ACCOUNT_FAIL"
export const DELETE_ACCOUNT_INIT    = "DELETE_ACCOUNT_INIT"
export const DELETE_ACCOUNT_SUCCESS = "DELETE_ACCOUNT_SUCCESS"
export const DELETE_ACCOUNT_FAIL    = "DELETE_ACCOUNT_FAIL"